var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99935 13.3332C3.77769 13.3332 1.16602 10.7215 1.16602 7.49984C1.16602 4.27817 3.77769 1.6665 6.99935 1.6665C10.221 1.6665 12.8327 4.27817 12.8327 7.49984C12.8327 10.7215 10.221 13.3332 6.99935 13.3332ZM6.99935 12.1665C9.57669 12.1665 11.666 10.0772 11.666 7.49984C11.666 4.92251 9.57669 2.83317 6.99935 2.83317C4.42202 2.83317 2.33268 4.92251 2.33268 7.49984C2.33268 10.0772 4.42202 12.1665 6.99935 12.1665ZM6.41602 4.58317H7.58268V5.74984H6.41602V4.58317ZM6.41602 6.9165H7.58268V10.4165H6.41602V6.9165Z",
    fill: "#B36800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5f50e7d57970257e43aa29a16b5760b6.svg";
export { ForwardRef as ReactComponent };